import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class AudioService {
  private audio: HTMLAudioElement;
  public isPlaying: boolean = false; // Zustand der Musik speichern
  public isPaused: boolean = false;
  public musicDisabled = localStorage.getItem("bgMusicDisabled") == "true";
  private playlist: string[] = [
    'assets/audio/a-private-detective.mp3',
    'assets/audio/funny-kids_medium.mp3',
    'assets/audio/secret-mission.mp3',
  ];
  private currentTrackIndex: number | null = null;

  constructor() {
    this.audio = new Audio();
    // this.audio.loop = true; // Musik wiederholen
    this.audio.volume = 0.1; // Lautstärke einstellen

    // Wenn ein Lied zu Ende ist, das nächste zufällige abspielen
    this.audio.addEventListener('ended', () => {
      this.playRandomTrack();
    });
  }

  private getRandomTrackIndex(): number {
    if (this.playlist.length === 1) return 0;

    let nextIndex;
    do {
      nextIndex = Math.floor(Math.random() * this.playlist.length);
    } while (nextIndex === this.currentTrackIndex); // optional: nicht dasselbe Lied direkt nochmal

    return nextIndex;
  }

  private playRandomTrack() {
    const nextIndex = this.getRandomTrackIndex();
    this.currentTrackIndex = nextIndex;
    this.audio.src = this.playlist[nextIndex];
    this.audio.play().then(() => {
      this.isPlaying = true;
      this.isPaused = false;
    }).catch((err) => {
      console.error('Audio Playback Error:', err);
    });
  }

  // Musik starten
  play() {
    if (!this.isPlaying && !this.isPaused) {
      this.playRandomTrack();
    } else if (this.isPaused) {
      this.audio.play().then(() => {
        this.isPlaying = true;
        this.isPaused = false;
      })
      .catch((err) => {
        console.error('Audio Playback Error:', err)
      });
    }
  }

  // Musik stoppen
  stop() {
    if (this.isPlaying || this.isPaused) {
      this.audio.pause();
      this.audio.currentTime = 0; // Zurück an den Anfang
      this.isPlaying = false;
      this.isPaused = false;
      this.currentTrackIndex = null;
    }
  }

  // Musik pausieren
  pause() {
    if (this.isPlaying) {
      this.audio.pause();
      this.isPlaying = false;
      this.isPaused = true;
    }
  }

  toggleBgMusicDisabled() {
    if(this.musicDisabled) {
      this.play();
      localStorage.setItem("bgMusicDisabled", "false");
    } else {
      this.stop();
      localStorage.setItem("bgMusicDisabled", "true");
    }
    this.musicDisabled = localStorage.getItem("bgMusicDisabled") == "true";
  }
}
